import { Libraries, useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_MAP_API_KEY } from "../../../constant/environment";

const MAPS_LIBRARIES: Libraries = ["places", "marker"];

// The first non-empty key, kept for the life of the page. js-api-loader builds one
// Loader per page and throws during render ("Loader must not be called again with
// different options") when a later caller passes another key, e.g. once getFEConfig
// swaps GOOGLE_MAP_API_KEY for the backend's value. App, AppMap and the hotel detail
// all load through this hook, so they all pass the same key.
let pinnedApiKey = "";

const mapsApiKey = (): string => {
  if (!pinnedApiKey && GOOGLE_MAP_API_KEY) pinnedApiKey = GOOGLE_MAP_API_KEY;
  return pinnedApiKey;
};

export const useMapsLoader = () =>
  useJsApiLoader({
    googleMapsApiKey: mapsApiKey(),
    libraries: MAPS_LIBRARIES,
    preventGoogleFontsLoading: false,
    language: "en",
  });

type AuthFailureWindow = Window & { gm_authFailure?: () => void };

const authFailureListeners = new Set<() => void>();
let authFailed = false;

if (typeof window !== "undefined") {
  const host = window as AuthFailureWindow;
  const previous = host.gm_authFailure;
  host.gm_authFailure = () => {
    authFailed = true;
    authFailureListeners.forEach((listener) => listener());
    previous?.();
  };
}

export const onMapsAuthFailure = (listener: () => void) => {
  if (authFailed) listener();
  authFailureListeners.add(listener);
  return () => {
    authFailureListeners.delete(listener);
  };
};
